import * as React from 'react';
import { 
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  TextField,
  Select,
  Popover
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { transform } from 'lodash';

const CDialog = styled(Dialog)({
  '>.MuiPaper-root': {
    borderRadius: '14px',
    boxShadow: '0 12px 48px rgba(0,0,0,0.18)'
  }
})

const CDialogTitle = styled(DialogTitle)({
  fontSize: '1.05rem',
  fontWeight: 600,
  padding: '1.1rem 1.5rem',
  color: '#1a1a2e',
  background: '#fff',
  borderBottom: '1px solid #f0f0f0'
})

const CDialogActions = styled(DialogActions)({
  borderTop: '1px solid #f0f0f0',
  padding: '0.85rem 1.5rem',
  gap: '0.5rem',
  background: '#fff'
})

const CButton = styled(Button)({
  border: '1px solid rgba(0,0,0,0.13)',
  color: '#424242',
  backgroundColor: '#f5f5f5',
  textTransform: 'none',
  borderRadius: '7px',
  fontWeight: 500,
  padding: '5px 18px',
  '&:hover': {
    backgroundColor: '#ececec'
  }
})

const CTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    backgroundColor: '#fafafa',
    fontSize: '0.9rem',
    '& fieldset': {
      borderColor: '#e0e0e0'
    },
    '&:hover fieldset': {
      borderColor: '#bdbdbd'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#6c63ff',
      borderWidth: '1.5px'
    }
  },
  '& .MuiInputLabel-root': {
    fontSize: '0.9rem',
    '&.Mui-focused': {
      color: '#6c63ff'
    }
  },
  '& .MuiInputBase-input': {
    padding: '10px 14px'
  }
})

const CSelect = styled(Select)({
  borderRadius: '8px',
  backgroundColor: '#fafafa',
  fontSize: '0.9rem',
  '& fieldset': {
    borderColor: '#e0e0e0'
  },
  '&:hover fieldset': {
    borderColor: '#bdbdbd'
  },
  '&.Mui-focused fieldset': {
    borderColor: '#6c63ff',
    borderWidth: '1.5px'
  }
})

const CFormControl = styled(FormControl)({
  // '>.MuiInputLabel-root': {
  //   left: 14,
  //   top: -12
  // }
})

const CSettingButton = styled(Button)({
  minWidth: 20,
  minHeight: 20,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textTransform: 'none',
  fontSize: '0.75rem',
  borderRadius: 4
})

const CSettingPopOver = styled(Popover)({
  '>.MuiPaper-root': {
    boxShadow: '1px 1px 12px rgba(115, 115, 115, 0.2)',
    border: '1px solid #E8E8E8',
    borderRadius: '0.5rem',
    paddingLeft: '0.25rem',
    paddingRight: '0.25rem',

    '>.MuiList-root': {
      paddingBottom: '0.25rem',
      paddingTop: '0.25rem',
      '>.MuiMenuItem-root': {
        paddingLeft: '0.5rem',
        paddingRight: '0.5rem',
        '.MuiListItemText-primary': {
          fontSize: '0.75rem',
          fontWeight: 300,
          lineHeight: 1.2
        }
      }
    }
  }
})

export {
  CButton,
  CDialog,
  CDialogTitle,
  CDialogActions,
  CFormControl,
  CTextField,
  CSelect,
  CSettingButton,
  CSettingPopOver
}